import React, { useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { change, Field, formValueSelector, reduxForm } from "redux-form";
import { handleApiErrors } from "../../lib/api-errors";
import { makeGetDataAccount } from "../../lib/selector";
import { setDataAccount } from "../client/actions";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

function PageVerify(props) {
  const history = useHistory();
  const dispatch = useDispatch();

  const { _handleToast, dataAccount, handleSubmit } = props;

  useEffect(() => {
    if (!dataAccount) {
      history.push("/open-account/check-info");
      return;
    }

    dispatch(change("pageVerify", "inputTypeVerify", "2"));
    dispatch(
      change(
        "pageVerify",
        "inputCallCenter",
        dataAccount?.C_PARAM_PERSONAL?.param?.C_FOLLOW_TRADING ?? "1"
      )
    );
    dispatch(change("pageVerify", "inputAccount1", true));
    dispatch(
      change(
        "pageVerify",
        "inputAccount6",
        dataAccount?.C_PARAM_PERSONAL?.param?.C_OPEN_MARGIN
          ? dataAccount?.C_PARAM_PERSONAL?.param?.C_OPEN_MARGIN === "1"
            ? true
            : false
          : true
      )
    );
    dispatch(change("pageVerify", "inputRead", true));
  }, []);

  function submit(values) {
    if (!values.inputRead) {
      _handleToast(
        "Quý khách chưa đồng ý với bộ điều khoản mở tài khoản.",
        "warning"
      );
      return;
    }
    let _data = Object.assign({}, dataAccount);
    _data.C_PARAM_PERSONAL.param.C_OPEN_MARGIN = values?.inputAccount6
      ? "1"
      : "0";
    _data.C_PARAM_PERSONAL.param.C_FOLLOW_TRADING = values?.inputCallCenter;
    dispatch(setDataAccount(_data));

    history.push("/open-account/preview");
    return;

    const url = `${apiUrl}/openAccount`;

    if (dataAccount?.C_PARAM_PERSONAL) {
      const request = fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(dataAccount?.C_PARAM_PERSONAL),
      });

      request
        .then(handleApiErrors)
        .then((response) => response.json())
        .then((json) => {
          if (json.iRs > 0) {
            // chưa có tài khoản
            let _data = Object.assign({}, dataAccount);
            _data.C_ACCOUNT_NO = json.data[0]?.SOTK;
            dispatch(setDataAccount(_data));

            history.push("/open-account/success");
            _handleToast("Mở tài khoản thành công", "success");
          } else {
            _handleToast(json.sRs, "error");

            // let _data = Object.assign({}, dataAccount);
            // _data.C_ACCOUNT_NO = '119CANHKHANH';
            // dispatch(setDataAccount(_data));

            // history.push("/open-account/success");
          }
        })
        .catch((error) => {
          throw error;
        });
    }
  }

  return (
    <>
      <Container>
        <Row>
          <Col lg="10" className="offset-lg-1">
            <div className="content pt180">
              <h2>Đăng ký dịch vụ</h2>
              <div className="yt-online-form-step mt-0 mb-5">
                {/* <div className="yt-alert-message alert alert-info" role="alert">
                  <BsInfoCircleFill /> Quý khách vui lòng đọc kỹ toàn bộ những
                  {" "}
                  này trước khi tham gia vào các bước tiếp theo trong hệ sinh
                  thái của chúng tôi.
                </div> */}
                <div className="">
                  <form
                    className="d-flex flex-column account-form mt-0"
                    onSubmit={handleSubmit(submit)}
                  >
                    <p className="mb-0 fz-20 font-weight-bold">
                      Quý khách vui lòng lựa chọn hình thức xác thực để mở tài
                      khoản
                    </p>
                    <p className="my-0 fz-16 pl-3 font-weight-bold">
                      I - Hình thức xác thực để mở tài khoản{" "}
                      <span className="text-danger">*</span>
                    </p>
                    <Form.Group className="check-custom mb-0 pl-5 w-100">
                      <Form.Label className="w-50">
                        <Field
                          name="inputTypeVerify"
                          component="input"
                          type="radio"
                          value="2"
                          className="mr-2"
                        />
                        Xác thực điện tử
                      </Form.Label>
                      <Form.Label className="text-nowrap w-50">
                        <Field
                          name="inputTypeVerify"
                          component="input"
                          type="radio"
                          value="1"
                          className="mr-2"
                        />
                        Hoàn thiện và gửi hồ sơ tại quầy
                      </Form.Label>
                    </Form.Group>
                    <p className="my-0 fz-16 pl-3 font-weight-bold">
                      II - Đăng ký sản phẩm dịch vụ{" "}
                    </p>
                    <Form.Group className="check-gender mb-0 pl-5 w-100">
                      {/* <Form.Label className="w-50">
                        <Field
                          name="inputAccount1"
                          component="input"
                          type="checkbox"
                          className="mr-2"
                          disabled
                        />
                        Tiểu khoản Giao dịch chứng khoán thường (1)
                      </Form.Label> */}

                      <div className="custom-radio" style={{ flex: "initial" }}>
                        <Field
                          name="inputAccount6"
                          component="input"
                          type="checkbox"
                          className="custom-control-input"
                          id="inputAccount6"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="inputAccount6"
                          style={{ fontWeight: "550" }}
                        >
                          Tài khoản Giao Dịch Ký Quỹ Chứng Khoán (6)
                        </label>
                      </div>

                      {/* <Form.Label>
                        <Field
                          name="inputAccount6"
                          component="input"
                          type="checkbox"
                          className="mr-2"
                        />
                        Tài khoản Giao Dịch Ký Quỹ Chứng Khoán (6)
                      </Form.Label> */}
                    </Form.Group>
                    {/* <p className="my-0">
                      II-{" "}
                      <a
                        href={
                          process.env.PUBLIC_URL +
                          "/BỘ ĐIỀU KHOẢN VÀ ĐIỀU KIỆN.pdf"
                        }
                        target="_blank"
                      >
                        {" "}
                        Bằng việc đồng ý với Điều khoản & Điều kiện của CASC
                        (*).
                      </a>{" "}
                      Quý khách vui lòng lựa chọn đăng ký sản phẩm dịch vụ sau:
                    </p>
                    <Form.Group className="check-gender mb-0">
                      <div
                        className="custom-radio w-50"
                        style={{ flex: "0 0 auto" }}
                      >
                        <Field
                          name="inputAccount1"
                          component="input"
                          type="checkbox"
                          className="custom-control-input"
                          id="inputAccount1"
                          disabled
                        />
                        <label
                          className="custom-control-label pr-3"
                          htmlFor="inputAccount1"
                          style={{ textTransform: "unset" }}
                        >
                          Tiểu khoản Giao dịch chứng khoán thường (1)
                        </label>
                      </div>
                      <div
                        className="custom-radio"
                        style={{ flex: "0 0 auto" }}
                      >
                        <Field
                          name="inputAccount6"
                          component="input"
                          type="checkbox"
                          className="custom-control-input"
                          id="inputAccount6"
                        />
                        <label
                          className="custom-control-label pr-3"
                          htmlFor="inputAccount6"
                          style={{ textTransform: "unset" }}
                        >
                          Tiểu khoản Giao dịch ký quỹ (6)
                        </label>
                      </div>
                    </Form.Group> */}
                    <p className="my-0 fz-16 pl-3 font-weight-bold">
                      III - Đăng ký giao dịch qua tổng đài{" "}
                      <span className="text-danger">*</span>
                    </p>
                    <Form.Group className="check-custom mb-0 pl-5 w-100">
                      <Form.Label className="w-50">
                        <Field
                          name="inputCallCenter"
                          component="input"
                          type="radio"
                          value="1"
                          className="mr-2"
                        />
                        Có
                      </Form.Label>
                      <Form.Label>
                        <Field
                          name="inputCallCenter"
                          component="input"
                          type="radio"
                          value="0"
                          className="mr-2"
                        />
                        Không
                      </Form.Label>
                    </Form.Group>
                    {/* <Form.Group className="check-gender mb-0">
                      <div
                        className="custom-radio"
                        style={{ flex: "0 0 auto" }}
                      >
                        <Field
                          name="inputCallCenter"
                          component="input"
                          type="radio"
                          value="1"
                          className="custom-control-input"
                          id="CallCenterY"
                        />
                        <label
                          className="custom-control-label pr-3"
                          htmlFor="CallCenterY"
                          style={{ textTransform: "unset" }}
                        >
                          Có
                        </label>
                      </div>
                      <div
                        className="custom-radio"
                        style={{ flex: "0 0 auto" }}
                      >
                        <Field
                          name="inputCallCenter"
                          component="input"
                          type="radio"
                          value="2"
                          className="custom-control-input"
                          id="CallCenterN"
                        />

                        <label
                          className="custom-control-label pr-3"
                          htmlFor="CallCenterN"
                          style={{ textTransform: "unset" }}
                        >
                          Không
                        </label>
                      </div>
                    </Form.Group> */}

                    <p className="my-0 fz-16">
                      <Form.Label>
                        <Field
                          name="inputRead"
                          component="input"
                          type="checkbox"
                          className="mr-2"
                        />
                        Tôi đã đọc, hiểu và đồng ý với{" "}
                        <a
                          href={
                            process.env.PUBLIC_URL +
                            "/BỘ ĐIỀU KHOẢN VÀ ĐIỀU KIỆN.pdf"
                          }
                          target="_blank"
                          className="font-weight-bold fs-i"
                          style={{
                            textDecoration: "underline",
                          }}
                        >
                          Bộ Điều Khoản Và Điều Kiện của Hợp Đồng Mở Tài Khoản
                          Giao Dịch Chứng Khoán.
                        </a>{" "}
                      </Form.Label>
                    </p>

                    <Row className="justify-content-center mt-2 mb-5">
                      <Button
                        onClick={() => history.goBack()}
                        className="prev-page"
                      >
                        Quay lại
                      </Button>
                      <Button className="btn-next" type="submit">
                        TIẾP TỤC
                      </Button>
                    </Row>
                  </form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

PageVerify = reduxForm({
  form: "pageVerify",
  enableReinitialize: true,
})(PageVerify);

const selector = formValueSelector("pageVerify");

const mapStateToProps = (state) => {
  const getDataAccount = makeGetDataAccount();

  const {
    inputTypeVerify,
    inputCallCenter,
    inputAccount1,
    inputAccount6,
    inputRead,
  } = selector(
    state,
    "inputTypeVerify",
    "inputCallCenter",
    "inputAccount1",
    "inputAccount6",
    "inputRead"
  );

  return {
    dataAccount: getDataAccount(state),

    inputTypeVerify,
    inputCallCenter,
    inputAccount1,
    inputAccount6,
    inputRead,
  };
};

export default connect(mapStateToProps)(PageVerify);
